module.exports = __webpack_public_path__ + "static/media/menu_settings.ecd2e919.svg";